<template>
  <v-card flat>
    <v-form style="width: 100%" ref="navigation-metadata-form" v-model="formIsValid">
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field box label="Field Name" v-model="fieldName" :rules="fieldNameRules"></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-select box label="Field Type" :items="fieldTypeNames" v-model="fieldType"></v-select>
        </v-flex>
        <v-flex xs12>
          <metadata-input-field v-if="!isTimeField" box v-model="fieldValue" :input-type="fieldType">
          </metadata-input-field>
          <DateRange v-if="isTimeField" class="mb-3" :rules="{ start: [rules.exists], end: [rules.exists] }" v-model="dates" box no-arrows :minDate="minDateBound" :maxDate="maxDateBound" />
        </v-flex>
        <v-flex xs12>
          <v-btn class="ma-0" color="info" block @click="submit()" :disabled="!formIsValid">
            {{ $t('Button.Add') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </v-card>
</template>
<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  import {
    MetadataMatchValuesFilter,
    MetadataMatchRangeFilter,
  } from '@/components/plugins/DataSetFilter'

  import FormValidationUtil from '@/components/mixins/FormValidationUtil'
  import MetadataUtil from '@/components/mixins/MetadataUtil'
  import MetadataInputField from '@/components/Metadata/MetadataInputField'
  import CustomDateRangePickerManualTimeSeries from '@/components/CustomDateRangePickerManualTimeSeries'

  import DateRange from '@/components/generic/DateRange'

  const datasetfilter = createNamespacedHelpers('datasetfilter')

  import {
    backendDateTimeFormat,
    formatDate,
  } from '@/components/mixins/MomentUtil'

  export default {
    components: {
      MetadataInputField,
      DateRange,
      'date-range-picker-manual': CustomDateRangePickerManualTimeSeries,
    },
    mixins: [FormValidationUtil, MetadataUtil],
    data() {
      return {
        fieldName: '',
        fieldType: 'String',
        fieldValue: '',
        dates: {
          start: null,
          end: null,
        },
        fieldValueMin: '',
        fieldValueMax: '',
        formIsValid: true,
        triggerResetToAutoDateRange: 0,
        fieldNameRules: [
          v => this.rules.required(v) || 'Please enter field name',
        ],
        rules: {
          exists: (v) => !!v || 'Required',
        },
      }
    },
    computed: {
      isTimeField() {
        return this.fieldType == 'DateTime'
      },
      minDateBound() {
        return null
      },
      maxDateBound() {
        return new Date()
      },
    },
    methods: {
      ...datasetfilter.mapActions(['addFilter']),
      submit() {
        let filter

        if (this.isTimeField) {
          filter = new MetadataMatchRangeFilter(
            this.fieldName,
            this.fieldType,
            formatDate(this.dates.start, backendDateTimeFormat),
            formatDate(this.dates.end, backendDateTimeFormat),
          )
        } else {
          filter = new MetadataMatchValuesFilter(
            this.fieldName,
            this.fieldType,
            this.fieldValue
          )
        }

        console.log(filter)
        this.addFilter(filter)
        this.$emit('instantSearchEvent', 'metadata')
      },
    },
  }
</script>
